<template>
  <div class="bc">
    <div class="formBox">
      <div class="formBox_box" v-for="(item, key) in headerList" :key="key">
        <div>{{ headForm[item.value] || 0 }}</div>
        <p>{{ item.text }}</p>
        <p class="br1" v-if="isAll"></p>
        <p class="br" v-else></p>
      </div>
    </div>
    <!-- 查询 -->
    <el-row :gutter="12" class="search-row">
      <el-col :span="8">
        <el-date-picker
          v-model="forms.dates1"
          type="daterange"
          value-format="yyyy-MM-dd"
          format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="奖励产生时间"
          end-placeholder="奖励产生时间"
          size="small"
          @change="commonChange"
        ></el-date-picker>
      </el-col>
      <el-col :span="5">
        <el-input
          prefix-icon="el-icon-search"
          type="text"
          v-model="forms.answerId"
          placeholder="答卷ID/答卷样本ID"
          size="small"
          clearable
          @blur="commonChange"
          @clear="commonChange"
        />
      </el-col>
      <el-col :span="3">
        <el-select
          v-model="forms.channelId"
          placeholder="子渠道"
          clearable
          :disabled="channelsListOptions.length === 0"
          size="small"
          @change="commonChange"
        >
          <el-option
            v-for="(item, index) in channelsListOptions"
            :key="index"
            :label="item.channel_name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="3">
        <el-select v-model="forms.sendStatus" placeholder="发放状态" clearable size="small" @change="commonChange">
          <el-option label="失败" value="0">失败</el-option>
          <el-option label="成功" value="1">成功</el-option>
          <el-option label="等待" value="2">等待</el-option>
        </el-select>
      </el-col>
      <!-- <el-col :span="3">
        <el-select v-model="forms.needHasAward" placeholder="奖励金额" clearable size="small" @change="commonChange">
          <el-option label="金额＞0" value="1">金额＞0</el-option>
          <el-option label="全部" value="0">全部</el-option>
        </el-select>
      </el-col> -->
    </el-row>
    <div class="text-right">
      <el-button class="tips-btn" size="small" icon="el-icon-download" @click="DownloadExportPDF"
        >导出PDF
        <div class="tips">
          <el-tooltip class="item" effect="light" content="导出财务报销凭证（带水印的PDF格式的文件）" placement="top-start">
            <!-- <img src="@/assets/img/tips_red.png" width="14" /> -->
            <i class="iconfont icon-shuoming text-theme-black-350 cursor-pointer text-small"></i>
          </el-tooltip>
        </div>
      </el-button>
      <el-button class="tips-btn" size="small" type="primary" icon="el-icon-download" @click="DownloadExportDetailExcel('answer')"
        >导出Excel
        <div class="tips">
          <el-tooltip class="item" effect="light" content="导出费用明细（Excel文件，可用于统计分析）" placement="top-start">
            <!-- <img src="@/assets/img/tips_red.png" width="14" /> -->
            <i class="iconfont icon-shuoming text-theme-black-350 cursor-pointer text-small"></i>
          </el-tooltip>
        </div>
      </el-button>
    </div>
    <data-table
      cell-class-name="truncate-table-cell-wrap"
      :data="data"
      :columns="option.column"
      :page="page"
      :showPage="true"
      :index="true"
      :indexFixed="true"
      :loading="loading"
      @size-change="sizeChange"
      @pagination-current-change="currentChange"
      :height="'calc(100vh - 323px)'"
    >
      <!-- 子渠道 12字以内单行显示，12字以上一行显示  只在全部 可用 -->
      <template #jlName="{ row }">
        <el-tooltip placement="top" effect="light" v-if="row.jlName && row.jlName.length > 12">
          <div slot="content">
            {{ row.jobId }}
            <br />
            {{ row.jlName }}
          </div>
          <div>{{ row.jlName.substring(0, 12) + '...' }}</div>
        </el-tooltip>
        <span v-if="row.jlName && row.jlName.length < 13">{{ row.jlName }}</span>
      </template>
      <!-- 等待状态时 不显示 发放/退款时间 -->
      <template #sentTime="{ row }">
        <span v-if="row.sendStatus !== '等待'">{{ row.sentTime }}</span>
      </template>
      <!-- 空状态 -->
      <template slot="empty">
        <empty-prompt :isAllOrNet="true" />
      </template>
    </data-table>
  </div>
</template>

<script>
import { getAnswerHList } from '@/api/wenjuan/cost'
import mixins from './cost-component-mixins'
import { assignment } from '@/assets/js/utils'
import GlobalConfig from '@/global/config'
import DataTable from '@/components/base/DataTable'
import EmptyPrompt from '@/components/base/EmptyPrompt'

export default {
  mixins: [mixins],
  components: {
    DataTable,
    EmptyPrompt
  },
  data() {
    return {
      loading: false,
      type: 5, // 答题奖励
      headForm: {
        paid: 0,
        amount: 0,
        answerNum: 0,
        answerAmount: 0
      },
      form: {
        money1: '',
        money2: '',
        nums1: '',
        nums2: ''
      }
    }
  },
  methods: {
    // 获取上部信息
    getHList() {
      const data = {
        surveyId: GlobalConfig.getSurveyId(),
        awardType: '1'
      }
      // 不是全部 就是网调；线下单独文件
      if (!this.isAll) {
        data.channel = 0 // 网络调查
      }
      getAnswerHList(data)
        .then(res => {
          const data = res.data.data
          assignment(data, this.headForm)
        })
        .catch(err => {})
    }
  }
}
</script>

<style scoped lang="scss">
@import '~@/assets/scss/line-style.scss';
.tips {
  position: absolute;
  top: 2px;
  right: 0px;
  cursor: pointer;
}
.tips-btn {
  position: relative;
}
</style>
